import { Component } from '@angular/core';
import { IonicPage,App, MenuController, ToastController, Platform, Events} from 'ionic-angular';
import { HomePage } from '../pages/home/home';
import firebase from 'firebase/app';
import { SearchPage } from '../pages/search/search';
import { BrokerSettingPage } from '../pages/broker_setting/broker_setting';
import { ThankyouPage } from '../pages/thankyou/thankyou';
import { BrokersPage } from '../pages/brokers/brokers';
import { AddContactPage } from '../pages/add-contact/add-contact';
import { TentativeRealEstateAssetPage } from '../pages/tentative-real-estate-asset/tentative-real-estate-asset';
import { UserData } from '../providers/loading/userData';
import { ViewContactPdfPage } from '../pages/view-contact-pdf/view-contact-pdf';
import { ApiCredentialsPage } from '../pages/api-credentials/api-credentials';
import { AcSettingsPage } from '../pages/ac-settings/ac-settings';
import { LoanAdminPage } from '../pages/loan-admin/loan-admin';
import * as $ from 'jquery'
import { DeletedRecordsPage } from '../pages/deleted-records/deleted-records';
import { LoadingProvider } from '../providers/loading/loading';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ChangeLogPage } from '../pages/change-log/change-log';
import { AngularFireAuth } from 'angularfire2/auth';
import { EnvDataService } from './services/env-data-service';
import {AdfPage} from '../pages/adf-page/adf-page';
import { ContactList } from '../pages/contact-list/contact_list';
import { AdfList } from '../pages/adf-list/adf-list';

// @IonicPage({
//   name: 'my-app',
//   segment: '/'
// })

@Component({
  selector: 'app-root',
  templateUrl: 'app.html',
  providers:[EnvDataService]
})
export class MyApp {
  rootPage:any;
  //public nav:NavController;
  public userRole: any;
  public uid: any;
  public myDate = '10-10-2019';
  public disabledDates: Date[] = [
    new Date(1545911005644),
    new Date(),
    new Date(2018, 12, 12), // Months are 0-based, this is August, 10th.
    new Date('Wednesday, December 26, 2018'), // Works with any valid Date formats like long format
    new Date('12-14-2018'), // Short format
  ];
  public datePickerObj: any = {
    inputDate: new Date('2018-08-10'), // default new Date()
    fromDate: new Date('2016-12-08'), // default null
    toDate: new Date('2018-12-28'), // default null
    showTodayButton: false, // default true
    closeOnSelect: true, // default false
    disableWeekDays: [4], // default []
    mondayFirst: true, // default false
    setLabel: 'S',  // default 'Set'
    todayLabel: 'T', // default 'Today'
    closeLabel: 'C', // default 'Close'
    disabledDates: this.disabledDates, // default []
    titleLabel: 'Select a Date', // default null
    monthsList: ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    weeksList: ["S", "M", "T", "W", "T", "F", "S"],
    dateFormat: 'YYYY-MM-DD', // default DD MMM YYYY
    clearButton : false , // default true
    momentLocale: 'pt-BR', // Default 'en-US'
    yearInAscending: true, // Default false
    btnCloseSetInReverse: true, // Default false
    btnProperties: {
      expand: 'block', // Default 'block'
      fill: '', // Default 'solid'
      size: '', // Default 'default'
      disabled: '', // Default false
      strong: '', // Default false
      color: '' // Default ''
    },
    arrowNextPrev: {
      nextArrowSrc: 'assets/images/arrow_right.svg',
      prevArrowSrc: 'assets/images/arrow_left.svg'
    } // This object supports only SVG files.
  };

  public contactUid : any;
  public document_id : any;
  public deleted_access : any;
  public deleted_access_menu_name: any;


  constructor(//public authService: AuthServiceProvider,
    public menuCtrl: MenuController,
    public toastCtrl: ToastController,
    public app: App,
    public platform: Platform,
    public events: Events,
    public userData: UserData,
    public loadingProvider: LoadingProvider,
    public afAuth: AngularFireAuth,
    public http : Http,
    private EnvDataService:EnvDataService
  ) {

    debugger;
    let me = this;

    //console.log(this.EnvDataService.EnvData.sendbox_api);
    this.contactUid = location.search.split('id=')[1];
    let contact_uid = location.search.split('id=')[1];
    let document_id = location.search.split('&docId=')[1];
    if(document_id != undefined){
      contact_uid = contact_uid.split('&docId=')[0];
    }
    this.userRole = window.localStorage.getItem("userRole");
    this.deleted_access = window.localStorage.getItem("deleted_access");
    if(this.deleted_access == 1){
      this.deleted_access_menu_name = 'Hide Deleted Records';
    }else{
      this.deleted_access_menu_name = 'Show Deleted Records';
    }

    console.log(this.uid);

    if(this.userRole == "broker" ){
       this.rootPage = 'BrokerDashboardPage';
      //this.rootPage=HomePage;
    }

    // if(this.userRole == "broker" || this.userRole == "super_admin" || this.userRole == "loan_admin"){
    //   if(this.contactUid == "" || this.contactUid == null || this.contactUid == undefined){
    //     this.rootPage = HomePage;
    //   }else{
    //     if(this.document_id == "" || this.document_id == null || this.document_id == undefined){
    //       // this.rootPage = ViewContactPage;
    //        console.log('abc');
    //       this.rootPage = ShowContactForm;
    //     }else{
    //       this.rootPage = ViewContactPdfPage;
    //     }
    //   }
    // }

    else if(this.userRole == "contact"){
      if(document_id == "" || document_id == null || document_id == undefined){
        // this.rootPage = ViewContactPage;
        debugger;
        console.log('abd');
        //this.rootPage = ShowContactForm;
        //this.menuCtrl.enable(false)
        this.rootPage ='CustomerDashboardPage';

        //  var nav = this.app.getRootNav();
        //   nav.setRoot(LoginPage);
        //  this.
      }else{
        this.rootPage = ViewContactPdfPage;
      }
    }else{
      // this.rootPage = LoginPage;
      this.rootPage = 'DashboardLoginPage';
    }

      //this.rootPage = LoginPage;

    // if(this.userRole == "broker" || this.userRole == "super_admin" || this.userRole == "loan_admin"){
    //   if(this.contactUid == "" || this.contactUid == null || this.contactUid == undefined){
    //      //this.rootPage = HomePage;
    //     this.rootPage = LoginPage;
    //   }else{
    //     if(this.document_id == "" || this.document_id == null || this.document_id == undefined){
    //       // this.rootPage = ViewContactPage;
    //        console.log('abc');
    //       this.rootPage = ShowContactForm;
    //     }else{
    //       this.rootPage = ViewContactPdfPage;
    //     }
    //   }
    // }else if(this.userRole == "contact"){
    //   if(document_id == "" || document_id == null || document_id == undefined){
    //     // this.rootPage = ViewContactPage;
    //     debugger;
    //     console.log('abd');
    //     //this.rootPage = ShowContactForm;
    //     //this.menuCtrl.enable(false)
    //     this.rootPage ='CustomerDashboardPage';
    //     //  var nav = this.app.getRootNav();
    //     //   nav.setRoot(LoginPage);
    //     //  this.
    //   }else{
    //     this.rootPage = ViewContactPdfPage;
    //   }
    // }else{
    //   this.rootPage = LoginPage;
    // }

    console.log(this.rootPage);

    this.afAuth.authState.subscribe(data => {
      console.log('user login', data);
      
      if(data){
      var docRef = firebase.firestore().collection("users").doc(data.uid);
      docRef.get().then(function(doc) {
        console.log('testing ',doc.data());
        if (doc.exists) {
          console.log('working ',doc.data());
          let user_data = doc.data();
          if(user_data.roles.super_admin){
            window.localStorage.setItem("userRole", 'super_admin');
            window.localStorage.setItem("brokerFirstname", user_data.firstname);
            window.localStorage.setItem("brokerLastname", user_data.lastname);
            window.localStorage.setItem("deleted_access", user_data.deleted_access);
          }else if(user_data.roles.broker){
            window.localStorage.setItem("userRole", 'broker');
            window.localStorage.setItem("brokerFirstname", user_data.firstname);
            window.localStorage.setItem("brokerLastname", user_data.lastname);
          }else if(user_data.roles.loan_admin){
            window.localStorage.setItem("userRole", 'loan_admin');
            window.localStorage.setItem("brokerFirstname", user_data.firstname);
            window.localStorage.setItem("brokerLastname", user_data.lastname);
          }else{
            window.localStorage.setItem("userRole", 'contact');
            window.localStorage.setItem("brokerFirstname", user_data.firstname);
            window.localStorage.setItem("brokerLastname", user_data.lastname);
          }
        }


      }).catch(function(error) {
        console.log("Error getting document:", error);
        me.app.getRootNav().setRoot('maintenace-Page');
      });
    } else {
      this.logoutClicked();
    }
    });

    events.subscribe('user:signedIn', (user, time) => {
      this.userRole = window.localStorage.getItem("userRole");
    });
  }


  shouldShow(){
    if(window.localStorage.getItem("uid") == '' || window.localStorage.getItem("uid") == null || window.localStorage.getItem("uid") == undefined){
      return false;
    }else{
      return true;
    }
  }

  logoutClicked() {
    //this.authService.logout();
    this.menuCtrl.close();
    window.localStorage.removeItem('uid');
    window.localStorage.removeItem('email');
    window.localStorage.removeItem('userRole');
    window.localStorage.removeItem('brokerFirstname');
    window.localStorage.removeItem('brokerLastname');
    window.localStorage.removeItem('contact_second_uid');
    window.localStorage.removeItem('contact_uid');
    window.localStorage.removeItem('random_id');
    window.localStorage.removeItem('SDF_form_document_id');
    window.localStorage.removeItem('deleted_access');
    this.userRole = window.localStorage.getItem("userRole");
    window.localStorage.clear();
    var nav = this.app.getRootNav();
    // nav.setRoot(LoginPage);
    nav.setRoot('DashboardLoginPage');
  }
  gotohomepage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(HomePage);
  }

  gotosettingpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(BrokerSettingPage);
  }

  gotoapicredentials(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(ApiCredentialsPage);
  }

  acSettings(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(AcSettingsPage);
  }

  gotobrokerpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(BrokersPage);
  }

  gotodeletedrecordspage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(DeletedRecordsPage);
  }

  gototentetivepage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(TentativeRealEstateAssetPage);
  }

  gotoCreateContactpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(AddContactPage);
  }

  gotoLoanAdminpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(LoanAdminPage);
  }

  gotoSDFpage(){
    window.localStorage.removeItem('edit_contact_uid');
    window.localStorage.removeItem('contact_uid');
    window.localStorage.removeItem('contact_second_uid');
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(AdfPage);
  }

  gotoAdfListpage(){
    // window.localStorage.removeItem('edit_contact_uid');
    // window.localStorage.removeItem('contact_uid');
    // window.localStorage.removeItem('contact_second_uid');
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(AdfList);
  }

  gotocontactlistpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(ContactList);
  }

  gotosearchpage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(SearchPage);
  }

  gotoThankYoupage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(ThankyouPage);
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  toggleSubmenu(){
    debugger;
    // this.menuCtrl.toggle();
    $('.arrowIcon').toggleClass('activeArrow');
    $('.menuParent').stop().toggleClass('activeSubmenu');
    $('.submenu').stop().slideToggle();
  }

  gotoChangeLog(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(ChangeLogPage);
  }

  gotoHideShowDeletedRecordspage(){
      this.deleted_access = window.localStorage.getItem("deleted_access");
      this.loadingProvider.startLoading();
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const requestOptions = new RequestOptions({ headers: headers });
      let deleted_access = 0;
      if(this.deleted_access == 0){
        deleted_access = 1;
      }
      let postData = {
        'deleted_access' : deleted_access,
        'uid' : this.uid
      }
      var url = this.EnvDataService.EnvData.sendbox_api+"/deletedAcessToAdmin";
      this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if(data['_body'] == 'success'){
          if(this.deleted_access == 0){
            this.presentToastSuccess('Deleted Acess show successfully.');
            this.deleted_access = 1;
            this.deleted_access_menu_name = 'Hide Deleted Records';
            window.localStorage.setItem("deleted_access", this.deleted_access);
          }else{
            this.presentToastSuccess('Deleted Acess hide successfully.');
            this.deleted_access = 0;
            this.deleted_access_menu_name = 'Show Deleted Records';
            window.localStorage.setItem("deleted_access", this.deleted_access);
          }
        }else{
          this.presentToastSuccess('Something went wrong please try again later.');
        }
        this.loadingProvider.stopLoading();
        var nav = this.app.getRootNav();
        nav.setRoot(HomePage);
      }, error => {
        this.presentToast(error.message);
        this.loadingProvider.stopLoading();
      });
  }
  gotosubscriptionpage() {
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot('SubscriptionPage');
  }
  
  gotodiscountpage() {
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot('DiscountPage');
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts